module.exports = __webpack_public_path__ + "images/img-26.ee5ca829.jpg";